import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useUserProfileQuery} from "../apis/authenticationApi";

const PrivateRoute = ({ roles }) => {
    const {data, isLoading, isError} = useUserProfileQuery();

    if(isLoading) {
        return (<></>);
    }

    else if(!isError && data?.id && (roles === undefined
        || roles.includes(data.role)
        || roles.includes(data.company?.role))) {
        return (<Outlet />);
    }
    else if(!isError && data?.id) {
        return (<Navigate to="/auth/not-authorized" />);
    }
    else {
        return (<Navigate to="/auth/login" />);
    }
}

export default PrivateRoute;
